import { Mail, Smartphone, MessageSquare } from "lucide-react";
import { CommunicationMethod } from "@api/shared-runtime/communication-method";

export type ChannelMeta = {
  label: string;
  helper: string;
  Icon: typeof Mail;
};

export type ChannelMetaMap = Record<CommunicationMethod, ChannelMeta>;

export const PROVIDER_CHANNEL_META: ChannelMetaMap = {
  [CommunicationMethod.EMAIL]: {
    label: "Email",
    helper: "Sent to your email address.",
    Icon: Mail,
  },
  [CommunicationMethod.PUSH_NOTIFICATION]: {
    label: "App notifications",
    helper: "Pushed to the Saile App on your phone.",
    Icon: Smartphone,
  },
  [CommunicationMethod.TEXT_MESSAGE]: {
    label: "Text message",
    helper: "Sent to your verified phone number.",
    Icon: MessageSquare,
  },
};

export const ORG_CHANNEL_META: ChannelMetaMap = {
  [CommunicationMethod.EMAIL]: {
    label: "Email",
    helper: "Sent to your work email address.",
    Icon: Mail,
  },
  [CommunicationMethod.PUSH_NOTIFICATION]: {
    label: "App notifications",
    helper: "Pushed to the Saile App on your phone.",
    Icon: Smartphone,
  },
  [CommunicationMethod.TEXT_MESSAGE]: {
    label: "Text message",
    helper: "Sent to your verified phone number.",
    Icon: MessageSquare,
  },
};
